// extracted by mini-css-extract-plugin
export var messageSideLeft = "_my-1";
export var messageSideRight = "_my-2";
export var subscribeToBackInStockBubbleContainer = "_my-0";